/** Only return to a charger start page in this app, never an arbitrary URL. */
export function balanceReturnPath(value: string | null): string {
  if (!value || value.length > 1000 || /[\\\r\n]/.test(value)) return '/scan';
  const path = value.split('?')[0] ?? '';
  return /^\/stations\/[a-z0-9][a-z0-9-]*\/stall\/[A-Za-z0-9][A-Za-z0-9_-]*$/.test(path)
    || /^\/charging-station\/[a-z0-9][a-z0-9-]*$/.test(path) ? value : '/scan';
}
